/**
 * With the new main sidebar after the 2025 navigation update, we provide an option to
 * collapse the sidebar via a floating button. We do this by updating a user settings in
 * our db, and also updateing a redux state to manage state real-time. However, this introduces
 * an edge-case where if the user reloads the page right after changing the sidebar state, even though
 * redux updates correctly, the next wreadite from the db happens before the previous write is complete,
 * Giving the appearance of a race condition where the sidebar and its content are not in sync.
 * This function updates the classes on the sidebar, navbar, and the main mount to reflect the correct state,
 * because we know the correct value once react is mounted.
 *
 * @param  {boolean} isCollapsed Whether the sidebar is collapsed
 * @return {void}
 */
export function resyncSidebarCollapseClasses(isCollapsed: boolean) {
    $('#app-react-mount').toggleClass('collapsed-sidebar', isCollapsed);
    $('#navbar').toggleClass('collapsed-sidebar', isCollapsed);
    $('#sidebar').toggleClass('collapsed', isCollapsed);
}
